// extracted by mini-css-extract-plugin
export var menuIcon = "_m7-0";
export var menuIconInline = "_m7-1";